<template>
  <svg :class="svgClass" aria-hidden="true" :style="styleInfo">
    <!-- use标签通过xlink:href指定图标ID（格式为#icon-图标名称） -->
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    // 图标名称（对应Iconfont中的图标ID，无需加#icon-前缀）
    iconClass: {
      type: String,
      required: true
    },
    // 自定义类名（用于调整样式）
    className: {
      type: String,
      default: ''
    },
    // 自定义样式（如大小、颜色等）
    styleInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 拼接完整的图标ID（#icon-前缀 + 图标名称）
    iconName() {
      return `#icon-${this.iconClass}`
    },
    // 组合自定义类名
    svgClass() {
      return this.className ? `svg-icon ${this.className}` : 'svg-icon'
    }
  }
}
</script>

<style scoped>
/* 基础样式：可根据需求调整 */
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em; /* 对齐文字 */
  fill: currentColor; /* 颜色继承父元素文字颜色 */
  overflow: hidden;
}
</style>